import React from 'react';
import ReactPlayer from 'react-player';
import { motion } from 'framer-motion';
import { openNewWindow } from '../../../../api/utils/util-func';
import {
  QuoteIcon,
  CircleRightArrowIcon,
  CircleDownArrowIcon,
} from '../wmw/WmwComp';
import questionBox from '../img/sec09-questionbox.png';

const VIDEO_URL = 'https://youtu.be/Q5W62ErjUBQ?si=3JdcYWqXl0EGnxOe';
const NOTION_URL =
  'https://alluring-viper-412.notion.site/2025-134768f77a398026bc63fba82bfc8899?pvs=143';

const HFHJSection9 = () => {
  return (
    <div className="bg-[#FE7020] p-3 py-10 md:py-20">
      <div className="m-auto w-full max-w-[520px]">
        <div className="flex flex-col gap-20">
          {/* 어떻게 도입할까요? */}
          <section className="flex flex-col gap-10">
            <div className="text-center font-['Pretendard'] text-3xl text-white md:text-4xl">
              <span className="font-bold text-[#FFD600]">HFHJ, </span>
              어떻게 도입할까요?
            </div>

            <div className="text-center font-['Pretendard'] text-base text-white md:text-lg">
              젭스영어주일학교의 Hello, Father! Hello, Jesus! 는
              <br />
              영어로 복음을 전하는 어떤 곳이든
              <br />
              자체 프로그램과 클래스로 활용할 수 있습니다.
            </div>

            <motion.div
              className="flex flex-col gap-8 md:gap-10"
              animate={{ x: 0 }}
            >
              <motion.div
                className="border-1 relative rounded-lg border-white text-base"
                initial={{ y: -20, opacity: 1 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 }}
              >
                <div className="absolute left-1/2 top-0 m-auto w-fit -translate-x-1/2 -translate-y-1/2 rounded-lg bg-[#FFD600] px-3 text-base font-bold text-black shadow md:text-lg">
                  Case 1
                </div>
                <div className="m-auto rounded-lg bg-white p-5 text-center text-sm font-medium md:p-6 md:text-lg">
                  주일학교, 영어예배 등 주일예배 프로그램으로 도입
                </div>
              </motion.div>

              <motion.div
                className="border-1 relative rounded-lg border-white text-base"
                initial={{ y: -20, opacity: 1 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <div className="absolute left-1/2 top-0 m-auto w-fit -translate-x-1/2 -translate-y-1/2 rounded-lg bg-[#FFD600] px-3 text-base font-bold text-black shadow md:text-lg">
                  Case 2
                </div>
                <div className="m-auto rounded-lg bg-white p-5 text-center text-sm font-medium md:p-6 md:text-lg">
                  토요일 특별 프로그램으로 도입
                </div>
              </motion.div>

              <motion.div
                className="border-1 relative rounded-lg border-white text-base"
                initial={{ y: -20, opacity: 1 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                <div className="absolute left-1/2 top-0 m-auto w-fit -translate-x-1/2 -translate-y-1/2 rounded-lg bg-[#FFD600] px-3 text-base font-bold text-black shadow md:text-lg">
                  Case 3
                </div>
                <div className="m-auto rounded-lg bg-white p-5 text-center text-sm font-medium md:p-6 md:text-lg">
                  선교지 영어 선교 클래스 프로그램으로 도입
                </div>
              </motion.div>

              <motion.div
                className="border-1 relative rounded-lg border-white text-base"
                initial={{ y: -20, opacity: 1 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                <div className="absolute left-1/2 top-0 m-auto w-fit -translate-x-1/2 -translate-y-1/2 rounded-lg bg-[#FFD600] px-3 text-base font-bold text-black shadow md:text-lg">
                  Case 4
                </div>
                <div className="m-auto rounded-lg bg-white px-3 py-5 text-center text-sm font-medium md:p-6 md:text-lg">
                  어린이집, 선교학교 등 교회 부속기관 프로그램으로 도입
                </div>
              </motion.div>
            </motion.div>
          </section>

          <section className="flex flex-col items-center justify-center gap-10 md:gap-10">
            <div className="flex flex-col">
              <motion.div
                initial={{ y: 0 }}
                animate={{ y: -10 }}
                transition={{
                  repeatType: 'reverse',
                  repeat: Infinity,
                  duration: 2,
                }}
              >
                <img src={questionBox} className="m-auto w-full max-w-20" />
              </motion.div>

              <div className="relative p-5">
                <div className="absolute -left-8 -top-4">
                  <QuoteIcon />
                </div>
                <div className="text-center font-['Pretendard'] text-3xl font-bold text-white md:text-4xl">
                  젭스영어주일학교가
                  <br /> 궁금하다면?
                </div>
                <div className="absolute -right-8 bottom-0 rotate-180">
                  <QuoteIcon />
                </div>
              </div>
            </div>

            <div className="flex w-full flex-col gap-5">
              <div>
                <div className="text-center font-['Pretendard'] text-base text-white md:text-xl">
                  젭스영어주일학교가 궁금하신가요?
                </div>
                <div className="flex items-center justify-center gap-2">
                  <CircleDownArrowIcon size={20} color="#FE7020" />
                  <span className="text-base font-bold text-[#FFD600] md:text-xl">
                    이 영상부터 보세요!
                  </span>
                  <CircleDownArrowIcon size={20} color="#FE7020" />
                </div>
              </div>

              <div className="aspect-video w-full overflow-hidden rounded-lg">
                <ReactPlayer
                  url={VIDEO_URL}
                  width="100%"
                  height="100%"
                  controls
                />
              </div>
            </div>

            <motion.div
              className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg bg-[#FFDA19] p-3 text-black"
              whileHover={{ opacity: 0.9, scale: 1.01 }}
              onClick={() => openNewWindow(NOTION_URL)}
            >
              <div className="text-base font-bold text-black md:text-lg">
                젭스영어주일학교 [도입제안서]
              </div>
              <CircleRightArrowIcon width={16} color="#000000" />
            </motion.div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HFHJSection9;
